// removed by extract-text-webpack-plugin
module.exports = {"component":"_3KoKs0R4SSYtlEMextu6PI","header":"_2MvaEXOtxLktrOfjd2ntQe","details":"_30ZUNb1BbiLqdAhtfB8k2K","detailsHeader":"_3OWMLJPPGpKuIWuudAhGHI","item":"_2SSCcu3k841CvJTSfoi-4y","externalLink":"_1NQe5nJBu-sXa3AwXqu32l","vcardBlock":"_3fh5Zbv9trD3o-n480h0g6","vcard":"_1_D9V9nOjxaMM2MBGXGZd3","heading":"_gqgYXtEvaAPOBUHgnfTI","vcardList":"_1lVbERCExFVQv2LZhBlVVq","vcardListItem":"_2lfGev2Q7tDNWmhAYgGpc3","child":"qPhmFpWJ2DD-bLo5x_ZX9","vcardContainer":"w1_kfzliykrAcRo3zRC-0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Home/PracticeLocation/PracticeLocation.css
// module id = 1209
// module chunks = 0